import register from 'preact-custom-element'
import { fetchProductByCollectionHandle } from 'libs/shopify-product'
import { useState, useEffect } from 'preact/hooks'
import { normalizeProducts } from '@/components/libs/shopify-normalize'
import ProductCarouselSimple from 'modules/product-carousel-simple/product-carousel-simple'
import { SkeletonProduct } from 'snippets/skeleton/skeleton'
import LoaderSpin from 'snippets/loader-spin/loader-spin'
import { fetchProductsLinked } from 'helpers/fetch'
import 'sections/searchspring-popular-product/searchspring-popular-product.css'
import './cart-related.css'

function CartRelated(props) {
  const settings = window.cartRelatedConfig
  const [products, setProducts] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const swiperOptions = {
    slidesPerView: 2.8,
    spaceBetween: 16,
    navigation: false,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    freeMode: {
      enabled: true,
      sticky: true
    },
    scrollbar: {
      draggable: true
    },
    centerInsufficientSlides: false,
    grabCursor: true,
    speed: 500
  }

  const getCartProductIds = async () => {
    try {
      const response = await fetch('/cart.js')
      const cart = await response.json()
      return cart.items.map(item => item.product_id.toString())
    } catch (error) {
      console.error('Error fetching cart:', error)
      return []
    }
  }

  const getSearchspringRecommendedProducts = async () => {
    try {
      if (settings.searchspringEnabled && settings.searchspringSiteId) {
        const productIds = await getCartProductIds() // Get cart product IDs

        const options = {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({
            profiles: [{ tag: settings.searchspringTag }],
            products: productIds
          })
        }

        const response = await fetch(
          `https://${settings.searchspringSiteId}.a.searchspring.io/boost/${settings.searchspringSiteId}/recommend`,
          options
        )

        const data = await response.json()
        const dataObject = data[0]

        if (dataObject?.results?.length > 0) {
          const result = normalizeProducts(dataObject.results, 'searchspring-recommended')
          return result
        }
      }

      // fallback to Shopify GraphQL related products
      const recommendations = await getRelatedProducts(settings.productsCollection)
      if (recommendations && recommendations.length > 0) {
        return normalizeProducts(recommendations, 'shopify-graphql')
      }

      return []
    } catch (err) {
      console.error('Searchspring fetch error:', err)
      return []
    }
  }

  const getRelatedProducts = async (collection) => {
    if (collection === null) return null
    const filters = [
      {
        available: true
      }
    ]
    return await fetchProductByCollectionHandle(collection, filters, 8)
  }

  useEffect(async () => {
    try {
      setIsLoading(true)
      const response = await getSearchspringRecommendedProducts()
      if (response && response.length > 0) {
        await fetchProductsLinked(response)
        setProducts(response)
      } else {
        setProducts([])
      }
    } catch (error) {
      console.log(error)
      setIsLoading(false)
    } finally {
      setIsLoading(false)
    }
  }, [])

  return (
    <div className="relative overflow-hidden">
      <div className="carousel-heading flex flex-col gap-1 max-w-[310px] sm:max-w-[496px] md:gap-2">
        {settings.title && <div className="border-t border-default title text-base pl-4 pr-4 mb-4 pt-8">
          {settings.title}
        </div>}
      </div>
      <div className="w-full">
        {isLoading ? (
          <div className="relative">
            <div className="hidden grid-cols-1 gap-4 2xl:grid 2xl:grid-cols-5">{SkeletonProduct(5)}</div>
            <div className="grid grid-cols-1 gap-4 lg-max:hidden lg:grid-cols-4 2xl:hidden">{SkeletonProduct(4)}</div>
            <div className="h-72 lg:hidden"><LoaderSpin width="8" height="8" /></div>
          </div>
        ) : (
          products && products.length > 0 ? (
            <ProductCarouselSimple products={products} scrollbar={true} navigation={false} centerSlides={true} options={swiperOptions} smallMode={true} className="product-carousel-related" />
          ) : (
            <div className="text-lg font-medium">No product</div>
          )
        )}
      </div>
    </div>
  )
}

export default CartRelated
